import { ChipTheme } from 'framework/chip/types';
import { field_background_theme, field_border_theme } from 'framework/field/constants';
import { colors } from 'framework/theme/constants/colors';
import { font_theme } from 'framework/theme/constants/font';

import { CHIP_VARIANT } from './enums';

export const chip_theme: Pick<ChipTheme, 'general'> = {
  general: {
    font_family: font_theme.general.font_family,
    font_size: font_theme.general.font_size_small,
    border_radius: '4px',
    padding: '4px 8px',
  },
};

export const chip_dark_theme: ChipTheme = {
  general: chip_theme.general,
  background: {
    normal: field_background_theme.normal,
    hover: field_background_theme.hover,
    focus: field_background_theme.focus,
  },
  border: {
    normal: field_border_theme.normal,
    hover: field_border_theme.hover,
    focus: field_border_theme.focus,
  },
};

export const DARK_CHIP_COLOR = {
  [CHIP_VARIANT.RED]: colors.red[10],
  [CHIP_VARIANT.GREEN]: colors.green[10],
  [CHIP_VARIANT.BLUE]: colors.blue[10],
  [CHIP_VARIANT.NAVY]: colors.navy[3],
  [CHIP_VARIANT.AQUA]: colors.aqua[4],
  [CHIP_VARIANT.YELLOW]: colors.yellow[3],
  [CHIP_VARIANT.LIVID]: colors.livid[3],
  [CHIP_VARIANT.PLATINUM]: colors.platinum[4],
  [CHIP_VARIANT.TEAL]: colors.teal[4],
  [CHIP_VARIANT.PURPLE]: colors.purple[7],
  [CHIP_VARIANT.ORANGE]: colors.orange[9],
  [CHIP_VARIANT.PINK]: colors.pink[5],
  [CHIP_VARIANT.LIGHT]: colors.light[5],
  [CHIP_VARIANT.DARK]: colors.dark[1],
};

export const DARK_CHIP_BORDER = {
  [CHIP_VARIANT.RED]: colors.red[11],
  [CHIP_VARIANT.GREEN]: colors.green[11],
  [CHIP_VARIANT.BLUE]: colors.blue[11],
  [CHIP_VARIANT.NAVY]: colors.navy[4],
  [CHIP_VARIANT.AQUA]: colors.aqua[5],
  [CHIP_VARIANT.YELLOW]: colors.yellow[4],
  [CHIP_VARIANT.LIVID]: colors.livid[4],
  [CHIP_VARIANT.PLATINUM]: colors.platinum[5],
  [CHIP_VARIANT.TEAL]: colors.teal[5],
  [CHIP_VARIANT.PURPLE]: colors.purple[8],
  [CHIP_VARIANT.ORANGE]: colors.orange[10],
  [CHIP_VARIANT.PINK]: colors.pink[6],
  [CHIP_VARIANT.LIGHT]: colors.light[6],
  [CHIP_VARIANT.DARK]: colors.dark[2],
};

export const DARK_FILL = {
  normal: field_background_theme.normal,
  focus: field_background_theme.focus,
  hover: field_background_theme.hover,
};

export const DARK_BORDER = {
  normal: field_border_theme.normal,
  focus: field_border_theme.focus,
  hover: field_border_theme.hover,
};
